module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-startseite-luftballons-65d73ceb0bd97396a6706b5e196b721a.png";